export default {
  data() {
    return {
      inputType: 'recaptcha',
      inputTypeDef: {}
    }
  }
}
